import { Image } from 'antd';
import male_cow from "../../assets/img/male_cow.png";
import female_cow from "../../assets/img/female_cow.png";
import male_goat from "../../assets/img/male_goat.png";
import female_goat from "../../assets/img/female_goat.png";
import male_sheep from "../../assets/img/male_sheep.png";
import female_sheep from "../../assets/img/male_sheep.png";

import { ANIMAL_TYPE_CARABAO,
ANIMAL_TYPE_CATTLE,
ANIMAL_TYPE_GOAT,
ANIMAL_TYPE_SHEEP,
ANIMAL_TYPE_SWINE } from '../../variables/constants';
import { API_URL } from 'constants';

const Matrix = ({ recordData, gender, extra, type='image', animalType }) => {
  

  const getImageSrc = (gender, animalType) => {
    if(recordData?.main_photo){
      return `${API_URL}/farm-animal/${recordData.id}/main-photo`;
    }

    switch(animalType){
      case ANIMAL_TYPE_CATTLE:
        return gender === 'male' ? male_cow : female_cow;
      case ANIMAL_TYPE_GOAT:
        return gender === 'male' ? male_goat : female_goat;
      case ANIMAL_TYPE_SHEEP:
        return gender === 'male' ? male_sheep : female_sheep;
      default:
        return gender === 'male' ? male_cow : female_cow;
    }
  }

  return (
    <>
    {recordData?.tag_id ?
      <div className={`animal-matrix !z-5 ${gender}  ${extra}`}>
        <div className={`frosted-glass animal-info ${recordData?.sire?.tag_id ? 'parent-line' : ''}`}>
          {type === 'image' ? 
            <div className="w-full">
              <div className="ml-[18px] flex h-[80px] w-auto flex-row items-center">
                <Image width="100%" src={getImageSrc(gender, animalType)} preview={false}/>
              </div>
              <p className="text-center font-dm text-md font-medium text-theme-700 dark:text-white">{recordData?.tag_id}</p>
            </div>
            :
            <>
              <p className="text-center font-dm text-md font-bold text-theme-700 dark:text-white">{recordData?.tag_id}</p>
              <div className="ml-[18px] h-[40px] w-full">
                <div className="font-medium">{recordData?.gender_name}</div>
                <div className="font-medium">{recordData?.breed_name}</div>
                <div className="font-medium">{recordData?.hybrid_details}</div>
              </div>
            </>
          }
        </div>
      </div>
      :
      <div className="w-[200px]"></div>
    }
    </>
  );
};

export default Matrix;
